// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, SchemaForm, Button } from "@components";
import { parseSchema } from "@utils/schema";

type OwnProps = $Exact<{
  department: Object,
  onSubmit: (formData: Object) => void,
  onClose: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  schema: Object | null,
}>;

export class RenameDepartmentModal extends React.Component<Props, OwnState> {
  state = {
    schema: null,
  };
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }
  componentDidMount() {
    parseSchema("HierarchyRenameOperationDTO").then(schema => {
      this.setState({
        schema,
      });
    });
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  getFormData = () => {
    return {
      newName: ((this.props.department || {}).data || {}).label,
      newOrganisationalUnitReference: ((this.props.department || {}).data || {}).reference,
    };
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onClose}>
          {this.props.t("RENAME_DEPARTMENT", {
            name: ((this.props.department || {}).data || {}).label || "Department",
          })}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            className="mx-auto"
            ref={this.formRef}
            formData={this.getFormData()}
            schema={this.state.schema || {}}
            onSubmit={this.handleSubmit}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(RenameDepartmentModal);
